<template></template>

<script>
    import {Listeners} from "keysso/constants/listeners";

    export default {
        data() {
            return {
                rollUp: false,
                style: {},
                selectedTo: [],
            }
        },
        mounted: function () {
            this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
        },
    }
</script>
